import { createRef, forwardRef, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Container, Row, Col, Button, Dropdown } from "react-bootstrap";
import { BzDatePicker, BzInputText, BzToolTip, BzDropdown, BzButton, BzTab, BzTabs } from "../../components";
import { WATCHLIST_GRID_INDEX, TL_INDEX, SUPPORT_RESISTANCE_VIEW, ORDER_ENTRY_CONSTANTS, OPTION_CHAIN, MAPPED_MARKET_SEGMENT_ID, LAYOUT_TYPE, MARKET_SEGMENT_ID } from '../../utils/global_variables';
import { useSelector, useDispatch } from 'react-redux';
import { toastConfig } from "../../redux/actions/toast";
import { useWFHMessages } from '../../hooks';
import { handleModal, handleModalData } from "../../redux/actions/modals";
import { getSipSettingDetails, getSipOrderFrequency, getScripOrderInfo } from "../../redux/actions/orders";
import { sendTouchlineRequest } from "../../apis/web_socket";
import { getWfhTouchlineLastTick } from "../../redux/actions/wfh";
import MarketOverviewModal from "../MarketOverview/MarketOverviewModal";
import dayjs from 'dayjs';
import SupportResistance from '../Analysis/SupportResistance';
import AllExchangesMarketDepth from '../AllExchangesMarketDepth';
import { calculateSupportRestistanceValues, isGuestUser } from "../../utils/global_functions";
import { InlineScripSeach } from "../Search";
import { resetSearchData } from "../../redux/actions/globalSearch";
import { setScripOverviewData } from "../../redux/actions/marketOverview";
import { updateScripAndOptionData } from "../../redux/actions/optionChain";
import moment from "moment";
import MarketDepthGrid from "../MarketOverview/MarketDepthGrid";
import uniqBy from 'lodash/uniqBy';


// Vinit Raut : 29-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start 
const objDropdownOptions = {
    quantity: ["Quantity", "Amount"],
    day_date: ["Date"],
    day: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"]
};
// Vinit Raut : 29-04-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End
const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        className={className}
    >
        {children}
    </div>
));
let frequency
let Weekly
let days
const OrderSip = (props) => {
    const { layoutType = LAYOUT_TYPE.HORIZONTAL, orderEntryTab, selectSpecificFrequencyDate, isVertical, handleOnSelectOrderOptionChange, selectOrderOption, handleDayChange, orderInputs, handleOrderInputs, marginInfoHandler, arrMarginInfo, scripOrderInfo, activeButtonToggleIndex, handleOrderStepsOnChange, isBrokerageDisabled, handleMarketDepthModal, objSelectOrderOptionInit,
        // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start 
        isModifyOrder = false, isReOrder = false, setOrderEntryTab, handleFortnightlyFrequencyChange,
        // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End 
        setSelectOrderOption, setOrderInputs, bIsSipAllowed
    } = props;
    const currentDate = new Date().toLocaleDateString("en-CA").split("/").reverse().join('-');

    const dispatch = useDispatch();
    const inlineSearchRef = useRef();
    const marketDepthRef = useRef(null);
    const [inputSearch, setInputSearch] = useState(false);


    const sipSettingDetails = useSelector(state => state?.orders?.sipSettingDetails);
    const frequencyType = useSelector(state => state?.orders?.getFrequency);
    const [wfhScripData, setWfhScripData] = useState([]);

    const [supportResistance, setSupportResistance] = useState({});
    const [marketDepthActiveTab, setMarketDepthActiveTab] = useState('MarketDepth');
    const arrScripExchanges = useSelector(state => state.orders.arrScripExchanges);
    const arrDistinctScripExchanges = useMemo(() => uniqBy(arrScripExchanges, WATCHLIST_GRID_INDEX.EXCHANGE), [arrScripExchanges]);
    const [marketDepthTab, setMarketDepthTab] = useState(MARKET_SEGMENT_ID.NSE_CASH);
    useEffect(() => {
        if (scripOrderInfo?.length > 0) {
            setIsShowMarketDepth(false);
            setMarketDepthTab(scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        } else { }
    }, [scripOrderInfo]);
    const [isShowMarketDepth, setIsShowMarketDepth] = useState(false);
    const [showSearch, setShowSearch] = useState(false);

    if (sipSettingDetails?.frequency_details) {
        frequency = Object.keys(sipSettingDetails?.frequency_details);
        Weekly = sipSettingDetails?.frequency_details?.WEEKLY?.specific_week_days;
        days = sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.specific_dates;

    } else {
        frequency = [];
        Weekly = [];
        days = [];
    }

    const handleArrGridRowData = useCallback((data) => {
        if (data[TL_INDEX.SEGMENT_ID]?.toString() === scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID]?.toString() && data[TL_INDEX.TOKEN]?.toString() === scripOrderInfo?.[WATCHLIST_GRID_INDEX.TOKEN]?.toString()) {
            setWfhScripData([...data]);
        } else {

        }
    }, [scripOrderInfo, setWfhScripData]);

    useEffect(() => {
        if (wfhScripData?.length != 0) {
            const resitancePivotObj = calculateSupportRestistanceValues(wfhScripData, 'Classic', '(H+L+C)/3');
            setSupportResistance(resitancePivotObj);
        } else { }
    }, [wfhScripData]);

    useWFHMessages('touchline', (e) => {
        handleArrGridRowData([...e?.detail]);
    });

    useEffect(() => {
        if (scripOrderInfo) {
            const arrSubscriptionScrips = [{ exchangeId: scripOrderInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN] }];
            sendTouchlineRequest(arrSubscriptionScrips);
        } else {

        }

    }, [scripOrderInfo]);

    useEffect(() => {
        getSipOrderFrequency();
    }, []);


    useEffect(() => {
        if (scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            const arrLastTickScripData = objLastTickData[scripOrderInfo?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
            if (arrLastTickScripData?.length > 0) {
                setWfhScripData([...arrLastTickScripData]);
            } else { }
        } else { }
    }, [dispatch, scripOrderInfo]);

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start           
    const orderData = useSelector(state => state.modals?.modalData?.orderData);
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End  

    useEffect(() => {
        const qtyInput = document.getElementById('qtyInput');
        if (qtyInput) {
            qtyInput?.focus();
            qtyInput?.select();
        }
    }, []);


    const handlePlaceOrderButton = useCallback((e) => {
        e?.preventDefault();
        const formattedStartDate = moment(orderInputs?.startDate).format("YYYY-MM-DD");

        if (isNaN(orderInputs?.numberOfInstallment) || orderInputs?.numberOfInstallment > sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_max || orderInputs?.numberOfInstallment < sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min) {

            dispatch(toastConfig({ autoDismiss: true, show: true, message: `No of Installment should be between  ${sipSettingDetails?.frequency_details[selectOrderOption?.frequency].installment_min} and ${sipSettingDetails?.frequency_details[selectOrderOption?.frequency].installment_max}` }));
        }
        else if (formattedStartDate < currentDate) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: 'start date should not be less than current date' }));
        }
        else if (isNaN(orderInputs.quantity) || orderInputs?.quantity < 1) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Quantity Or Amount must be provided' }));

        }

        else {
            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': false }, { 'ORDER_ENTRY_CONFIRMATION': true }, isModifyOrder && { 'MODIFY_ORDER_MODAL': false }], true));
            dispatch(handleModalData({
                data: {
                    layoutType, orderEntryTab,
                    activeButtonToggleIndex, scripOrderInfo,
                    selectOrderOption, orderInputs, objSelectOrderOptionInit,
                    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start           
                    orderData, isModifyOrder, isReOrder,
                    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End           
                }
            }));
        }

    }, [sipSettingDetails, dispatch, activeButtonToggleIndex, currentDate, orderEntryTab, orderInputs, layoutType, objSelectOrderOptionInit, scripOrderInfo, selectOrderOption,
        //    Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
        isModifyOrder
        //    Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    ]);

    useEffect(() => {
        if (Object.keys(sipSettingDetails).length <= 0) {
            if (!isGuestUser()) {
                dispatch(getSipSettingDetails());
            } else { }
        }
    }, [sipSettingDetails]);

    // Srikantrao-BT-102676 Breeze - SIP Order entry/changes and added Dispatch for marketOverView_start 

    const handleScripOverview = () => {
        //{/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start */ }
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        //{/* Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End */ }
        dispatch(updateScripAndOptionData({ instrumentName: scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT], symbol: scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL], instrument: scripOrderInfo?.[WATCHLIST_GRID_INDEX.INSTRUMENT], id: scripOrderInfo?.[WATCHLIST_GRID_INDEX?.SEGMENT_ID], token: scripOrderInfo[WATCHLIST_GRID_INDEX.ASSET_TOKEN] === 0 ? scripOrderInfo[WATCHLIST_GRID_INDEX.TOKEN] : scripOrderInfo[WATCHLIST_GRID_INDEX.ASSET_TOKEN], bestFive: true, location: OPTION_CHAIN.OVERVIEW }));
        dispatch(handleModalData({ tab: 'overview' }));
        // handleMarketDepthModal(scripOrderInfo, true, true);
        dispatch(setScripOverviewData(scripOrderInfo));
    };
    // Srikantrao-BT-102676 Breeze - SIP Order entry/Commented and added Dispatch for marketOverView_end 


    const hanldeKeyDown = (e) => {
        const { name } = e.target;
        if (e.key === '.' || e.key === '-' || e.key === '+') {
            e.preventDefault();
        }
        if (e.which === 38 || e.which === 40) {
            e.preventDefault();
            if (e.which === 38) {
                handleOrderStepsOnChange(name, 'increase');
            } else if (e.which === 40) {
                handleOrderStepsOnChange(name, 'decrease');
            }
        }

    };

    const onDateChange = (date, dateString) => {
        if (dateString) {
            handleOrderInputs({ target: { name: 'startDate', value: dateString } });
        } else {

        }

    };

    const disabledDate = (current) => {
        if (!isModifyOrder) {
            const today = dayjs();
            const startOfDay = today.startOf('day');
            return (
                current && (current.isBefore(startOfDay))
            );
        }
    };



    const isDisbledQuatityInc = useMemo(() => {
        return orderInputs?.quantity == ORDER_ENTRY_CONSTANTS.QUANTITY_MAX_RANGE;
    }, [orderInputs?.quantity]);
    const isDisbledQuatityDec = useMemo(() => {
        return orderInputs?.quantity == 0 || isNaN(orderInputs?.quantity);
    }, [orderInputs?.quantity]);

    const isDisbledCapPriceInc = useMemo(() => {
        return orderInputs?.capPrice == ORDER_ENTRY_CONSTANTS.CAP_PRICE_MAX_RANGE;
    }, [orderInputs?.capPrice]);

    const isDisbledCapPriceDec = useMemo(() => {
        return orderInputs?.capPrice == 0 || isNaN(orderInputs?.capPrice);
    }, [orderInputs?.capPrice]);

    const isDisbledNoOfInstallmentInc = useMemo(() => {
        return orderInputs?.numberOfInstallment == ORDER_ENTRY_CONSTANTS.NUMBER_OF_INSTALLMENT_MAX_RANGE;
    }, [orderInputs?.numberOfInstallment]);

    const isDisbledNoOfInstallmentDec = useMemo(() => {
        return orderInputs?.numberOfInstallment == 0 || isNaN(orderInputs?.numberOfInstallment);
    }, [orderInputs?.numberOfInstallment]);

    // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - Start 
    const handleSelectScripFromGlobalSearch = (scrip) => {
        if (scrip?.length > 0) {
            if (scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] == MAPPED_MARKET_SEGMENT_ID.MAPPED_NSE_CASH || scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID] == MAPPED_MARKET_SEGMENT_ID.MAPPED_BSE_CASH) {
                dispatch(getScripOrderInfo({ isBuySell: activeButtonToggleIndex, scripData: scrip }));
                dispatch(resetSearchData());
                setInputSearch(false);
                setTimeout(() => {
                    const searchIconButton = document.getElementById('searchIcon');
                    if (searchIconButton) {
                        searchIconButton?.focus();
                    }
                }, 10);
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `SIP orders can be placed only on Equity Segment` }));
            }
        }

    };
    // Vinit Raut : 16-01-2024 : BT-107249 -  Breeze – SIP Order entry bug fixing BT-102676  - End

    const handleOnShowSearch = () => {
        setShowSearch(!showSearch);
    };
    // Srikantrao-BT-102676 Breeze - SIP Order entry
    useEffect(() => {
        const clickFunction = (event) => {
            if (inputSearch) {
                if (!inlineSearchRef?.current?.contains(event.target) && !event.target.matches('.inline-search-scrip-list, .inline-search-scrip-list *')) {
                    setInputSearch(false);
                    setTimeout(() => {
                        const searchIconButton = document.getElementById('searchIcon');
                        if (searchIconButton) {
                            searchIconButton?.focus();
                        }
                    }, 10);

                } else { }
            } else { }
        };
        document.addEventListener('mousedown', clickFunction);
        return () => {
            document.removeEventListener('mousedown', clickFunction);
        };
    }, [inputSearch]);
    // Srikantrao-BT-102676 Breeze - SIP Order entry
    // Hari K:19-11-2024:seting capPrice on clicking of marketdepth values-start
    const onValueClick = (value) => {
        const nValue = parseFloat(value);
        setOrderInputs(curr => ({ ...curr, scripPrice: nValue, capPrice: nValue.toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) })); //BT-142330 :Hotfix Bug fixing : ManasaB : 27-08-2024 : Order SIP Market Depth issue 
    };
    // Hari K:19-11-2024:seting capPrice on clicking of marketdepth values-end
    return (
        <>
            <Container fluid className='p-0'>
                <MarketOverviewModal scripOverviewData={scripOrderInfo} handleMarketDepthModal={handleMarketDepthModal} layoutType={layoutType} />
                <form onSubmit={handlePlaceOrderButton}>
                    {layoutType === LAYOUT_TYPE.HORIZONTAL && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] !== '' ?
                        (bIsSipAllowed ?
                            <>
                                <Row className='g-0 pt-2'>
                                    <Col md={12} className='d-flex justify-content-start align-items-center'>
                                        {inputSearch || scripOrderInfo?.length <= 0
                                            ?
                                            <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setInputSearch} />
                                            :
                                            <>
                                                <div data-testid='symbol' className='font-medium font-size4 color-text text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                                <div className='chips-wrap'>
                                                    <div data-testid='exchange' className='exchange-chip me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                </div>
                                                {scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] &&
                                                    <div data-testid='series' className='font-regular font-size4 color-subtext text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES]}</div>
                                                }
                                                <div className='font-medium font-size4 color-text me-1'>{wfhScripData?.[TL_INDEX.LAST_TRADE_PRICE]}</div>
                                                <div className={`font-regular font-size4 color-text me-2 ${wfhScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] >= 0 ? 'color-positive' : 'color-negative'}`}>
                                                    {wfhScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]} ({wfhScripData?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]}%)
                                                </div>
                                                <BzButton className='icon-btn' type='button' onClick={handleScripOverview}><span data-testid='overview' className='icon-16 icon-eye icon-dark'></span></BzButton>
                                                <BzButton className='icon-btn ms-2' type='button' id='searchIcon' onClick={() => setInputSearch(true)}><span data-testid='search' className='icon-16 icon-search icon-dark'></span></BzButton>
                                            </>
                                        }
                                    </Col>
                                </Row>
                                <Row className='g-0 mt-4'>
                                    <Col md={2} className='pe-3'>
                                        <div className='d-flex align-items-center mb-1'>
                                            <div className='font-regular font-size2 color-subtext'>{selectOrderOption?.orderBy === "Amount" ? <><span>{selectOrderOption?.orderBy + " in "}</span><span>&#8377;</span></> : selectOrderOption?.orderBy}</div>
                                            <Dropdown className='d-flex align-items-center'>
                                                <Dropdown.Toggle as={CustomDropdownToggle} className='icon-12 icon-arrowdown icon-dark ms-2'></Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {objDropdownOptions?.quantity.map((eachOption, i) => (
                                                        <Dropdown.Item onClick={(e) => handleOnSelectOrderOptionChange({ target: { name: 'orderBy', value: eachOption } })} key={i} value={eachOption}>{eachOption}</Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div className='input-group postion-relative'>
                                            <div data-testid='quantitydecrease' className={`icon-12 icon-order-decrease input-number-left-wrap ${isDisbledQuatityDec && 'disabled'}`} name="quantity" id='quantitydecrease' onClick={() => handleOrderStepsOnChange('quantity', 'decrease')} type='button' ></div>
                                            <BzInputText data-testid='qtyInput' size='sm' type='number' name='quantity' autoFocus className='text-center p-0 font-regular' value={orderInputs?.quantity} min={0} max={99999} onChange={handleOrderInputs} onKeyDown={hanldeKeyDown} id='qtyInput' />
                                            <div data-testid='quantityincrease' className={`icon-12 icon-order-increase input-number-right-wrap ${isDisbledQuatityInc && 'disabled'}`} name='quantity' id='quantityincrease' onClick={() => handleOrderStepsOnChange('quantity', 'increase')} type='button' disabled={true} ></div>
                                        </div>
                                    </Col>
                                    <Col md={3} className='pe-3'>
                                        <div className='d-flex justify-content-between mb-1'>
                                            <div className='d-flex align-items-center'>
                                                <div className='font-regular font-size2 color-subtext'>Cap price</div>
                                                <BzToolTip placement='right' TooltipMsg="Don't buy above this price">
                                                    <div className='icon-14 icon-info icon-dark ms-2'></div>
                                                </BzToolTip>
                                            </div>
                                            <div className='icon-20 icon-marketdepth ms-3' onClick={() => setIsShowMarketDepth(curr => !curr)}></div>
                                        </div>
                                        <div className='input-group postion-relative'>
                                            <div data-testid='capricedecrease' className={`icon-12 icon-order-decrease input-number-left-wrap ${isDisbledCapPriceDec && 'disabled'}`} name='capPrice' id='capPricedecrease' onClick={() => handleOrderStepsOnChange('capPrice', 'decrease')}></div>
                                            <BzInputText data-testid='capInput' size='sm' type='number' name='capPrice' value={orderInputs?.capPrice} className='font-regular text-center' min={0} max={999999} onChange={handleOrderInputs} onKeyDown={hanldeKeyDown} />
                                            <div data-testid='capriceincrease' className={`icon-12 icon-order-increase input-number-right-wrap ${isDisbledCapPriceInc && 'disabled'}`} name='capPrice' id="capPriceincrease" onClick={() => handleOrderStepsOnChange('capPrice', 'increase')}></div>
                                        </div>
                                        {/* <div className='d-flex align-tems-center mt-2'>
                                        <BzToolTip placement='right' TooltipMsg='You can place your order within this price range. It is defined by the exchanges or the nature of trade you are placing.'>
                                            <div className='icon-16 icon-info icon-dark'></div>
                                        </BzToolTip>
                                        <div className='font-medium font-size1 color-subtext'>Range: <span className='color-text ms-1'>{wfhScripData?.[TL_INDEX.DAILY_PRICE_RANGE]}</span></div>
                                    </div> */}
                                    </Col>
                                    <Col className='pe-3'>
                                        <div className='font-regular font-size2 color-subtext mb-1'>Frequency</div>
                                        <div className='Bzmodalselect-dropdown'>
                                            <BzDropdown>
                                                <Dropdown.Toggle data-testid='frequencyInput' className='btn-default'>{selectOrderOption?.frequency}</Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {frequency?.map((each, i) => <Dropdown.Item data-testid={`frquency-item`} key={i} onClick={(e) => handleOnSelectOrderOptionChange({ target: { name: 'frequency', value: each } })}>{each}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </BzDropdown>
                                        </div>
                                    </Col>
                                    {/* When Frequency is selected as 'FORTHNIGHTLY' these below col's should be visible*/}
                                    {selectOrderOption?.frequency === frequencyType?.forthnightly ? <Col md={2} className='pe-3'>
                                        <div className='font-regular font-size2 color-subtext mb-1'>Every</div>
                                        <div className='Bzmodalselect-dropdown'>
                                            <BzDropdown>
                                                <Dropdown.Toggle className='btn-default' data-testid='fortnightly-every'>{selectOrderOption?.selectSpecificFrequencyDate ? selectOrderOption?.selectSpecificFrequencyDate : days?.[0]}</Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {days?.map((day => <Dropdown.Item onClick={(e) => handleFortnightlyFrequencyChange({ target: { value: day, name: 'Date' } })}>{day}</Dropdown.Item>))}
                                                </Dropdown.Menu>
                                            </BzDropdown>
                                        </div>
                                    </Col> : null}
                                    {/* When Frequency is selected as 'MONTHLY' these below col's should be visible*/}
                                    {selectOrderOption?.frequency === frequencyType?.monthly && (days?.length >= 1 && days[0] !== "") ?
                                        <>
                                            {/* BT-107418- 30/04/2024 - Vinit R -Breeze SIP order entry issues -- Start */}
                                            <Col md={2} className='pe-3'>
                                                <div className='font-regular font-size2 color-subtext mb-1'>Every</div>
                                                <div className='Bzmodalselect-dropdown'>
                                                    <BzDropdown>
                                                        <Dropdown.Toggle data-testid='monthly-every' className='btn-default'>{selectOrderOption?.selectSpecificFrequencyDate ? selectOrderOption?.selectSpecificFrequencyDate : days?.[0]}</Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {days?.map((day => <Dropdown.Item id="day" onClick={(e) => handleFortnightlyFrequencyChange({ target: { value: day, name: 'selectSpecificFrequencyDate' } })}>{day}</Dropdown.Item>))}
                                                        </Dropdown.Menu>
                                                    </BzDropdown>
                                                </div>
                                            </Col>
                                            {/* BT-107418- 30/04/2024 - Vinit R -Breeze SIP order entry issues -- End */}

                                            {selectOrderOption?.day_date === 'Day' && <Col md={2} className='pe-3'>
                                                <div className='font-regular font-size2 color-subtext mb-1'>Day</div>
                                                <div className='Bzmodalselect-dropdown'>
                                                    <BzDropdown>
                                                        <Dropdown.Toggle className='btn-default'>{selectOrderOption?.day}</Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {objDropdownOptions?.day?.map((eachOption, i) => (
                                                                <Dropdown.Item key={i} onClick={(e) => handleOnSelectOrderOptionChange({ target: { value: eachOption, name: 'day' } })}>{eachOption}</Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                    </BzDropdown>
                                                </div>
                                            </Col>}
                                        </> : null}

                                    {/* when Frequency is WEEKLY these 'Every' select should be visible */}
                                    {selectOrderOption?.frequency === frequencyType.weekly &&
                                        <Col md={2} className='pe-3'>
                                            <div className='font-regular font-size2 color-subtext mb-1'>Every</div>
                                            <div className='Bzmodalselect-dropdown'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle data-testid='every-weekly' className='btn-default'>{selectOrderOption?.everyForWeekly}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {Weekly?.map((eachOption, i) => (
                                                            <Dropdown.Item key={i} onClick={(e) => handleOnSelectOrderOptionChange({ target: { value: eachOption, name: 'everyForWeekly' } })}>{eachOption}</Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>
                                        </Col>
                                    }
                                    <Col>
                                        <div className='font-regular font-size2 color-subtext mb-1'>No. of installments</div>
                                        <div className='input-group postion-relative'>
                                            <div data-testid='noofinstallmentdecareae' className={`icon-12 icon-order-decrease input-number-left-wrap ${isDisbledNoOfInstallmentDec && 'disabled'}`} name='numberOfInstallment' id='numberOfInstallmentdecrease' onClick={() => handleOrderStepsOnChange('numberOfInstallment', 'decrease')}></div>
                                            <BzInputText data-testid='noofinstallment' size='sm' type='number' name='numberOfInstallment' value={orderInputs?.numberOfInstallment} className='font-regular text-center' onChange={handleOrderInputs} onKeyDown={hanldeKeyDown} min={0} />
                                            <div data-testid='noofinstallmentincareae' className={`icon-12 icon-order-increase input-number-right-wrap ${isDisbledNoOfInstallmentInc && 'disabled'}`} name='numberOfInstallment' id='numberOfInstallmentincrease' onClick={() => handleOrderStepsOnChange('numberOfInstallment', 'increase')} ></div>
                                        </div>
                                        <div className='d-flex align-tems-center mt-2'>
                                            <div className='font-medium font-size1 color-subtext ms-1'>Range:
                                                <span className='color-text ms-1'>
                                                    {
                                                        sipSettingDetails.frequency_details ? (
                                                            `${sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min} - ${sipSettingDetails?.frequency_details[selectOrderOption.frequency]?.installment_max}`
                                                        )
                                                            : ''
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-4'>
                                    <Col md='auto'>
                                        <div className='font-regular font-size2 color-subtext mb-1'>Start Date</div>
                                        <div className='datepicker-wrap'>
                                            {/* Vinit Raut : 05-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- Start  */}
                                            <BzDatePicker className='form-datepicker-primary'
                                                defaultValue={!isModifyOrder ? orderInputs?.startDate ? dayjs(orderInputs?.startDate) : dayjs() : ''} name='startDate' dateFormat={"MMM DD, YYYY"} picker={"date"}
                                                disabledDate={disabledDate}
                                                onDateChange={onDateChange} />
                                            {/* Vinit Raut : 05-03-2024 : BT-107418 -  Breeze – SIP Order entry bug fixing BT-102676 -- End */}
                                        </div>
                                    </Col>
                                </Row>
                            </> :
                            <Row className='g-0 mt-3 mb-4'>
                                <Col md={12} className='m-auto oe-note-card'>
                                    <div className='d-flex align-items-center'>
                                        <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                        <div className='font-medium font-size3 color-text ms-2'>SIP orders are not allowed for this scrip</div>
                                    </div>
                                </Col>
                            </Row>)
                        : layoutType === LAYOUT_TYPE.HORIZONTAL &&
                        <Row className='g-0 mt-3 mb-4'>
                            <Col md={12} className='m-auto oe-note-card'>
                                <div className='d-flex align-items-center'>
                                    <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                    <div className='font-medium font-size3 color-text ms-2'>SIP orders can be placed only on Equity Segment</div>
                                </div>
                            </Col>
                        </Row>
                    }

                    {layoutType == LAYOUT_TYPE.HORIZONTAL && <>
                        <Row className='bdr-top pt-3'>
                            <Col className='d-flex justify-content-end align-items-center'>
                                <button className={`btn btn-md ${activeButtonToggleIndex === 0 ? 'btn-positive' : 'btn-negative'} text-capitalize`} onClick={handlePlaceOrderButton} disabled={isNaN(orderInputs.quantity) || orderInputs?.quantity < 1 || isNaN(orderInputs?.numberOfInstallment) || (orderInputs?.numberOfInstallment) > (sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_max) || (orderInputs?.numberOfInstallment < sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_min) || scripOrderInfo?.length <= 0 || !bIsSipAllowed}>
                                    {isModifyOrder ? 'MODIFY ORDER' : 'PLACE ORDER'}
                                </button>
                            </Col>
                        </Row>
                        {
                            isShowMarketDepth &&
                            <Row className='g-0 bdr-top px-2 py-3 mt-3'>
                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-start align-items-center'>
                                        <div ref={marketDepthRef} className='submenu-wrapper d-flex align-items-center'>
                                            <div onClick={() => setMarketDepthActiveTab('MarketDepth')} className={`submenuItem ${marketDepthActiveTab == 'MarketDepth' ? 'active' : ''}`}>Market Depth</div>
                                            <div onClick={() => setMarketDepthActiveTab('supportResistance')} className={`submenuItem ${marketDepthActiveTab == 'supportResistance' ? 'active' : ''}`}>Support/Resistance</div>
                                        </div>
                                    </Col>
                                </Row>
                                <div>
                                    {marketDepthActiveTab === "MarketDepth" ? <AllExchangesMarketDepth heading={false} /> : marketDepthActiveTab === "supportResistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} /> : null}
                                </div>
                            </Row>
                        }
                    </>
                    }
                </form>

                {layoutType === LAYOUT_TYPE.VERTICAL ?
                    <div className='sticky-orderticket-ordersip'>
                        <Container fluid className='g-0 px-3 mt-2'>
                            {isVertical ?
                                <>
                                    {scripOrderInfo && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] != '' ?
                                        (bIsSipAllowed ?
                                            <>
                                                {inputSearch || scripOrderInfo?.length <= 0 ?
                                                    <Row className='g-0 mb-3'>
                                                        <Col>
                                                            <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setInputSearch} />
                                                        </Col>
                                                    </Row>
                                                    :
                                                    <>
                                                        <Row className='g-0'>
                                                            <Col md={8} className='d-flex justify-content-start align-items-start'>
                                                                <Container fluid className='p-0'>
                                                                    <Row className='g-0'>
                                                                        <Col className='d-flex justify-content-start align-items-center'>
                                                                            <div className='font-medium font-size4 color-text text-uppercase me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                                                            <div className='chips-wrap'>
                                                                                <div className='exchange-chip me-2'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.EXCHANGE]}</div>
                                                                            </div>
                                                                            <div className='icon-16 icon-eye icon-dark flex-shrink-0 me-2' onClick={handleScripOverview}></div>
                                                                            <div className='icon-16 icon-search icon-dark flex-shrink-0' id='searchIcon' onClick={() => setInputSearch(true)}></div>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row className='g-0 mt-1'>
                                                                        <Col className='d-flex justify-content-start align-items-end'>
                                                                            <div className='font-regular font-size4 color-subtext'>{scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES]}</div>
                                                                        </Col>
                                                                    </Row>
                                                                </Container>
                                                            </Col>
                                                        </Row>
                                                        <Row className='g-0'>
                                                            <Col className='d-flex justify-content-start align-items-start'>
                                                                <div className='font-medium font-size4 color-text'>{wfhScripData?.[TL_INDEX.LAST_TRADE_PRICE]}</div>
                                                                <div className={`font-regular font-size4 color-text ms-1 ${wfhScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] >= 0 ? 'color-positive' : 'color-negative'}`}>{(wfhScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] / scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) >= 0 ? `+${(wfhScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] / scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])}` : (wfhScripData?.[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] / scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR]).toFixed(scripOrderInfo[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH])} ({wfhScripData?.[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE]}%)</div>
                                                            </Col>
                                                        </Row>
                                                    </>
                                                }
                                            </> :
                                            <Row className='g-0'>
                                                <Col md={12} className='m-auto oe-note-card'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                        <div className='font-medium font-size3 color-text ms-2'>SIP orders are not allowed for this scrip</div>
                                                    </div>
                                                </Col>
                                            </Row>) : scripOrderInfo ?
                                            <>
                                                <Row className='g-0'>
                                                    <Col md={12} className='m-auto oe-note-card'>
                                                        <div className='d-flex align-items-center'>
                                                            <div className='icon-16 icon-info icon-dark flex-shrink-0'></div>
                                                            <div className='font-medium font-size3 color-text ms-2'>SIP orders can be placed only on Equity Segment</div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {/* <Row className='g-0 py-2'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <InlineScripSeach ref={inlineSearchRef} handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} setBToggleSearchBar={setInputSearch} />
                                        </Col>
                                    </Row> */}
                                            </>
                                            : null}
                                    {showSearch && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] != '' ?
                                        <Row className='g-0 py-2'>
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <InlineScripSeach handleSelectScripFromGlobalSearch={handleSelectScripFromGlobalSearch} />
                                            </Col>
                                        </Row>
                                        : null}
                                </>
                                :
                                <>
                                    {
                                        scripOrderInfo && bIsSipAllowed && scripOrderInfo?.[WATCHLIST_GRID_INDEX.SERIES] != '' ?
                                            <>
                                                <Row className='mb-3'>
                                                    <Col md={6}>
                                                        <div className='d-flex align-items-center mb-1'>
                                                            <div className='font-regular font-size2 color-subtext'>{selectOrderOption?.orderBy}</div>
                                                            <Dropdown className='d-flex align-items-center'>
                                                                <Dropdown.Toggle as={CustomDropdownToggle} className='icon-12 icon-arrowdown icon-dark ms-2'></Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {objDropdownOptions?.quantity.map((eachOption, i) => (
                                                                        <Dropdown.Item onClick={(e) => handleOnSelectOrderOptionChange({ target: { name: 'orderBy', value: eachOption } })} key={i} value={eachOption}>{eachOption}</Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                        <div className='input-group postion-relative'>
                                                            <div className={`icon-12 icon-order-decrease input-number-left-wrap ${isDisbledQuatityDec && 'disabled'}`} name="quantity" id='quantitydecrease' onClick={() => handleOrderStepsOnChange('quantity', 'decrease')} type='button'></div>
                                                            <BzInputText size='sm' type='number' className='font-regular text-center' autoFocus name='quantity' value={orderInputs?.quantity} onChange={handleOrderInputs} onKeyDown={hanldeKeyDown} min={0} max={99999} />
                                                            <div className={`icon-12 icon-order-increase input-number-right-wrap ${isDisbledQuatityInc && 'disabled'}`} name='quantity' id='quantityincrease' onClick={() => handleOrderStepsOnChange('quantity', 'increase')} ></div>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className='d-flex justify-content-between mb-1'>
                                                            <div className='d-flex align-items-center'>
                                                                <div className='font-regular font-size2 color-subtext'>Cap price</div>
                                                                <BzToolTip placement='left' TooltipMsg="Don't buy above this price">
                                                                    <div className='icon-16 icon-info icon-primary ms-2'></div>
                                                                </BzToolTip>
                                                            </div>
                                                            <div className='icon-20 icon-marketdepth ms-3' onClick={() => {
                                                                setIsShowMarketDepth(curr => {
                                                                    if (!curr) {
                                                                        setTimeout(() => {
                                                                            marketDepthRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                                                        }, 100);
                                                                    }
                                                                    return !curr;
                                                                });
                                                            }}></div>
                                                        </div>
                                                        <div className='input-group postion-relative'>
                                                            <div className={`icon-12 icon-order-decrease input-number-left-wrap ${isDisbledCapPriceDec && 'disabled'}`} name='capPrice' id='capPricedecrease' onClick={() => handleOrderStepsOnChange('capPrice', 'decrease')}></div>
                                                            <BzInputText size='sm' type='number' className='font-regular text-center'
                                                                name='capPrice' value={orderInputs?.capPrice} onChange={handleOrderInputs} onKeyDown={hanldeKeyDown} min={0} max={999999} />
                                                            <div className={`icon-12 icon-order-increase input-number-right-wrap ${isDisbledCapPriceInc && 'disabled'}`} name='capPrice' id='capPriceincrease' onClick={() => handleOrderStepsOnChange('capPrice', 'increase')} min={0}></div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Col md={6}>
                                                        <div className='font-regular font-size2 color-subtext mb-1'>Frequency</div>
                                                        <div className='Bzmodalselect-dropdown'>
                                                            <BzDropdown>
                                                                <Dropdown.Toggle className='btn-default'>{selectOrderOption?.frequency}</Dropdown.Toggle>
                                                                <Dropdown.Menu>
                                                                    {frequency?.map((each, i) => <Dropdown.Item key={i} onClick={(e) => handleOnSelectOrderOptionChange({ target: { name: 'frequency', value: each } })}>{each}</Dropdown.Item>)}
                                                                </Dropdown.Menu>
                                                            </BzDropdown>
                                                        </div>
                                                    </Col>
                                                    {selectOrderOption?.frequency === frequencyType?.forthnightly ?
                                                        <Col md={6}>
                                                            <div className='font-regular font-size2 color-subtext mb-1'>Every</div>
                                                            <div className='Bzmodalselect-dropdown'>
                                                                <BzDropdown>
                                                                    <Dropdown.Toggle className='btn-default'>{selectOrderOption?.selectSpecificFrequencyDate ? selectOrderOption?.selectSpecificFrequencyDate : days?.[0]}</Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        {days?.map((day => <Dropdown.Item onClick={(e) => handleFortnightlyFrequencyChange({ target: { value: day, name: 'Date' } })}>{day}</Dropdown.Item>))}
                                                                    </Dropdown.Menu>
                                                                </BzDropdown>
                                                            </div>
                                                        </Col> :
                                                        selectOrderOption?.frequency === frequencyType?.monthly && (days?.length >= 1 && days[0] !== "") ?
                                                            <Col md={6}>
                                                                <div className='font-regular font-size2 color-subtext mb-1'>Every</div>
                                                                <div className='Bzmodalselect-dropdown'>
                                                                    <BzDropdown>
                                                                        <Dropdown.Toggle className='btn-default'>{selectOrderOption?.selectSpecificFrequencyDate ? selectOrderOption?.selectSpecificFrequencyDate : days?.[0]}</Dropdown.Toggle>
                                                                        <Dropdown.Menu>
                                                                            {days?.map((eachOption, i) => (
                                                                                <Dropdown.Item key={i} id="day" onClick={(e) => handleFortnightlyFrequencyChange({ target: { value: eachOption, name: 'Date' } })}>{eachOption}</Dropdown.Item>
                                                                            ))}
                                                                        </Dropdown.Menu>
                                                                    </BzDropdown>
                                                                </div>
                                                            </Col> : selectOrderOption?.frequency === frequencyType.weekly ?
                                                                <Col md={6}>
                                                                    <div className='font-regular font-size2 color-subtext mb-1'>Every</div>
                                                                    <div className='Bzmodalselect-dropdown'>
                                                                        <BzDropdown>
                                                                            <Dropdown.Toggle className='btn-default'>{selectOrderOption?.everyForWeekly}</Dropdown.Toggle>
                                                                            <Dropdown.Menu>
                                                                                {Weekly?.map((eachOption, i) => (
                                                                                    <Dropdown.Item key={i} id="day" onClick={(e) => handleOnSelectOrderOptionChange({ target: { value: eachOption, name: 'everyForWeekly' } })}>{eachOption}</Dropdown.Item>
                                                                                ))}
                                                                            </Dropdown.Menu>
                                                                        </BzDropdown>
                                                                    </div>
                                                                </Col>
                                                                : null}
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Col md={6}>
                                                        <div className='font-regular font-size2 color-subtext mb-1'>No. of installments</div>
                                                        <div className='input-group postion-relative'>
                                                            <div className={`icon-12 icon-order-decrease input-number-left-wrap ${isDisbledNoOfInstallmentDec && 'disabled'}`} name='numberOfInstallment' id="numberOfInstallmentdecrease" onClick={() => handleOrderStepsOnChange('numberOfInstallment', 'decrease')}></div>
                                                            <BzInputText size='sm' type='number' className='font-regular text-center' name='numberOfInstallment' value={orderInputs?.numberOfInstallment} onChange={handleOrderInputs} onKeyDown={hanldeKeyDown} min={sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_min} max={sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_max} />
                                                            <div className={`icon-12 icon-order-increase input-number-right-wrap ${isDisbledNoOfInstallmentInc && 'disabled'}`} name='numberOfInstallment' id="numberOfInstallmentincrease" onClick={() => handleOrderStepsOnChange('numberOfInstallment', 'increase')} ></div>
                                                        </div>
                                                        <div className='d-flex align-tems-center mt-2'>
                                                            <div className='font-medium font-size1 color-subtext ms-1'>Range:
                                                                <span className={`${orderInputs?.numberOfInstallment !== '0' ? sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_min <= orderInputs?.numberOfInstallment && sipSettingDetails?.frequency_details?.[selectOrderOption?.frequency]?.installment_max >= orderInputs?.numberOfInstallment ? 'color-text' : 'color-error' : 'color-text'}`}>
                                                                    {
                                                                        sipSettingDetails.frequency_details ? (
                                                                            `${sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_min} - ${sipSettingDetails?.frequency_details[selectOrderOption?.frequency]?.installment_max}`
                                                                        )
                                                                            : ''
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md={6}>
                                                        <div className='font-regular font-size2 color-subtext mb-1'>Start Date</div>
                                                        <div className='datepicker-wrap'>
                                                            <BzDatePicker className='form-datepicker-primary' defaultValue={!isModifyOrder ? orderInputs?.startDate ? dayjs(orderInputs?.startDate) : dayjs() : ''} name='startDate' dateFormat={"YYYY-MM-DD"} picker={"date"} onDateChange={onDateChange} disabledDate={disabledDate} />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </> : null
                                    }
                                    {isShowMarketDepth &&
                                        <div ref={marketDepthRef} className='bdr-top py-3'>
                                            <Row className='g-0'>
                                                <Col md={11} className='d-flex justify-content-start align-items-center'>
                                                    <Button className={marketDepthActiveTab === "MarketDepth" ? 'btn btn-sm btn-primary btn-rounded me-2' : 'btn btn-sm btn-default btn-rounded me-2'} onClick={() => setMarketDepthActiveTab('MarketDepth')}>Market Depth</Button>
                                                    <Button className={marketDepthActiveTab === "supportResistance" ? 'btn btn-sm btn-primary btn-rounded' : 'btn btn-sm btn-default btn-rounded'} onClick={() => setMarketDepthActiveTab('supportResistance')}>Support/Resistance</Button>
                                                </Col>
                                            </Row>
                                            {marketDepthActiveTab === "MarketDepth" ?
                                                <>
                                                    <BzTabs className='nav nav-tabs horizontal-scroll-wrap my-2 d-flex flex-row'>
                                                        {
                                                            arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                                <BzTab key={i} className={`nav-link text-capitalize ${each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab ? 'active' : ''}`} tabKey={each[WATCHLIST_GRID_INDEX.SEGMENT_ID]} onClick={() => setMarketDepthTab(each[WATCHLIST_GRID_INDEX.SEGMENT_ID])}>
                                                                    {each[WATCHLIST_GRID_INDEX.EXCHANGE]}
                                                                </BzTab>
                                                            )
                                                        }
                                                    </BzTabs>
                                                    {
                                                        arrDistinctScripExchanges?.length > 0 && arrDistinctScripExchanges?.map((each, i) =>
                                                            each[WATCHLIST_GRID_INDEX.SEGMENT_ID] == marketDepthTab && <MarketDepthGrid onValueClick={onValueClick} layoutType={LAYOUT_TYPE.VERTICAL} ref={[createRef(), createRef()]} key={i} scripData={each} />
                                                        )
                                                    }
                                                </>
                                                : marketDepthActiveTab === "supportResistance" ? <SupportResistance supportResistance={supportResistance} strViewFrom={SUPPORT_RESISTANCE_VIEW.ORDER_ENTRY} /> : null}
                                        </div>
                                    }
                                </>
                            }
                        </Container>
                    </div>
                    :
                    null
                }
            </Container >

        </>


    );
};

export default memo(OrderSip);